import React from 'react';

function Briefcase({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        d="M12.375 9.61875V7.3125C12.375 6.11903 12.8491 4.97443 13.693 4.13052C14.5369 3.28661 15.6815 2.8125 16.875 2.8125H19.125C20.3185 2.8125 21.4631 3.28661 22.307 4.13052C23.1509 4.97443 23.625 6.11903 23.625 7.3125V9.50625"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M20.25 24.1875H34.875V11.8125C34.875 11.2158 34.6379 10.6435 34.216 10.2215C33.794 9.79955 33.2217 9.5625 32.625 9.5625H18M33.75 24.1875V33.1875H18"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M15.75 24.1875H1.125V11.8125C1.125 11.2158 1.36205 10.6435 1.78401 10.2215C2.20597 9.79955 2.77826 9.5625 3.375 9.5625H18M2.25 24.1875V33.1875H18"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M15.75 21.9375H20.25V26.4375H15.75V21.9375Z"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Briefcase;
